import { Breadcrumb, Fabric, ProgressIndicator } from 'office-ui-fabric-react';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
  loadOrganizationsWithContainers,
  removeApiKey,
  setSelectedContainer,
  showBrandfolder,
  showGettingStarted
} from '../../actions';
import OrganizationList from '../../components/OrganizationList/OrganizationList';
import Title from '../../components/Title/Title';
import { getAllContainers, getAllOrganizations, getLoadingBrandfolder, getLoadingOrganization } from '../../selectors';

import './Brandfolders.css';

class Brandfolders extends React.Component {
  static propTypes = {
    containers: PropTypes.array,
    isBrandfolderLoading: PropTypes.bool.isRequired,
    isOrganizationLoading: PropTypes.bool.isRequired,
    organizations: PropTypes.array,
    removeApiKey: PropTypes.func.isRequired,
    setContainer: PropTypes.func.isRequired,
    showGettingStarted: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.loadOrganizationsWithContainers();
  }

  render() {
    return (
      <Fabric>
        <Title onLogout={() => this.logout()}>Choose Brandfolder</Title>
        <Breadcrumb
          items={[
            { text: 'Brandfolders', key: 'brandfolders', onClick: () => null, isCurrentItem: true }
          ]}
          ariaLabel={'Breadcrumb'}
        />
        {this.props.isBrandfolderLoading &&
          this.props.isOrganizationLoading && (
            <div className="loading">
              <ProgressIndicator label="Loading Brandfolders" />
            </div>
          )}
        {!this.props.isBrandfolderLoading &&
          !this.props.isOrganizationLoading &&
          this.props.containers &&
          this.props.organizations && (
            <OrganizationList
              containers={this.props.containers}
              onClick={container => this.props.setContainer(container)}
              organizations={this.props.organizations}
            />
          )}
      </Fabric>
    );
  }

  logout() {
    this.props.removeApiKey();
    this.props.showGettingStarted();
  }
}

const mapStateToProps = state => ({
  containers: getAllContainers(state),
  isBrandfolderLoading: getLoadingBrandfolder(state),
  isOrganizationLoading: getLoadingOrganization(state),
  organizations: getAllOrganizations(state)
});

const mapDispatchToProps = dispatch => ({
  loadOrganizationsWithContainers: () => dispatch(loadOrganizationsWithContainers()),
  removeApiKey: () => dispatch(removeApiKey()),
  setContainer: container => {
    dispatch(setSelectedContainer(container));
    dispatch(showBrandfolder());
  },
  showGettingStarted: () => dispatch(showGettingStarted())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Brandfolders);



// WEBPACK FOOTER //
// ./src/containers/Brandfolders/Brandfolders.js